module.exports = "<span class=\"db-folder-nav\">\n  <span></span>\n</span>"